import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormLabel, FormInputSearch, Chip } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip", "options", "multiple", "onClear"],
  _excluded2 = ["id", "disabled", "readonly"];
var Chips = function Chips(_ref) {
  var multiple = _ref.multiple,
    value = _ref.value,
    handleClear = _ref.handleClear;
  if (multiple && value !== null && value !== void 0 && value.value) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        overflowX: 'auto',
        whiteSpace: 'nowrap'
      }
    }, value === null || value === void 0 ? void 0 : value.value.map(function (v) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: "chip-".concat(v.value),
        closeProps: {
          'aria-label': 'Dismiss'
        },
        onClick: function onClick() {
          return handleClear(v.value);
        },
        text: v.label
      });
    }));
  }
  return null;
};
var Search = /*#__PURE__*/React.memo(function (props) {
  var _useField = useField(_objectSpread2({}, props)),
    fieldState = _useField.fieldState,
    fieldApi = _useField.fieldApi,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    options = userProps.options,
    multiple = userProps.multiple,
    _onClear = userProps.onClear,
    inputProps = _objectWithoutProperties(userProps, _excluded);
  var id = inputProps.id,
    disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    restInputProps = _objectWithoutProperties(inputProps, _excluded2);
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched,
    setFocused = fieldApi.setFocused,
    getValue = fieldApi.getValue;
  var handleClear = function handleClear(v) {
    var current = getValue();
    if (current.value) {
      var newValue = {
        value: current.value.filter(function (val) {
          return val.value != v;
        })
      };
      setValue(newValue);
    }
  };
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "text",
    disabled: disabled,
    readOnly: readonly
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(Chips, {
    multiple: multiple,
    value: value,
    handleClear: handleClear
  }), /*#__PURE__*/React.createElement(FormInputSearch, _extends({}, restInputProps, {
    autoComplete: "off",
    id: id,
    disabled: disabled,
    value: !(value !== null && value !== void 0 && value.label) && (value === null || value === void 0 ? void 0 : value.label) !== 0 ? '' : value.label,
    onChange: function onChange(e) {
      if (!multiple) {
        var v = {
          label: e.target.value
        };
        setValue(v, e);
      } else {
        var _v = _objectSpread2(_objectSpread2({}, getValue()), {}, {
          label: e.target.value
        });
        setValue(_v, e);
      }
    },
    onOptionSelect: function onOptionSelect(_ref2) {
      var _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? '' : _ref2$value;
      if (!multiple) {
        var option = options.find(function (op) {
          return op.value === value;
        });
        setValue(option);
      } else {
        // Get the selected option
        var _option = options.find(function (op) {
          return op.value === value;
        });
        // Get current value as we want to update it not override it
        var current = getValue();
        var newValue = current !== null && current !== void 0 && current.value ? [].concat(_toConsumableArray(current.value), [_option]) : [_option];
        setValue({
          value: newValue
        });
      }
    },
    onClear: function onClear(e) {
      if (!multiple) {
        setValue(undefined);
      } else {
        setValue(_objectSpread2(_objectSpread2({}, getValue()), {}, {
          label: undefined
        }));
      }
      if (_onClear) {
        _onClear(e);
      }
    },
    onBlur: function onBlur(e) {
      setTouched(true, e);
    },
    onFocus: function onFocus(e) {
      setFocused(true, e);
    },
    readOnly: readonly,
    inputRef: ref,
    "aria-invalid": showError,
    "aria-describedby": showError || feedback || helper ? "".concat(id, "-feedback") : undefined,
    options: options
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError,
    id: "".concat(id, "-feedback")
  })));
});

export { Search };
